import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, MenuItem, Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material'
import { DatePicker } from '@mui/lab';
import GridBreak from '../../../../components/GridBreak'
import IFramePopUp from '../../../../components/Pop_ups/IFramePopUp';
import DragFiles from "../../../../components/FileManagement/DragFiles";
import { fileTo64Arr, handleFormNumbers } from "../../../../util/generalHelp";
import { createContractDraft, submitDraft, removeOfferDraft, getFieldClause } from "../../../../util/offerLettersHelp";
import { previewDocusign } from "../../../../util/docusignHelper";
import { useBeforeunload } from 'react-beforeunload';
import { useBackListener } from "../../../../util/Hooks";
import moment from "moment";
import { getProfileFromEmail } from "../../../../util/ProfileHelper";

function MasterOfServicesUSA(props) {

    const defaultObj = {
            document_args: {
                "salary": 0,
                "job_title": "",
                "rate_type": "daily",
                venue: 'New York, NY',
                jurisdiction: 'New York',
                contractor_name: "",
                seq_hire_helper: "",
                seq_hire_statement: "SEQ shall maintain the right to hire Contractor from COMPANY after X months of service under this contract.  Nothing contained in the foregoing paragraph shall terminate this right during the pendency of this contract.",
                service_description: ""
            },
            region: 'USA',
            name: "",
            email_address: "",
            authority_id: null,
            "return_url": window.location.origin.toString(),
            venue_id: "",
            state_id: "",
    
        }

    /* All of the fields that can be added to the Master of Services agreement, which initially we assume are not present */   
    const defaultFieldsMasterServices = {
        non_exclusive: false,
        placement_company_employees: false,
        relationship_parties: false,
        SEQ_duties: false,
        placement_term: false,
        intellectual_property: false,
        non_competition_company: false,
        non_competition_SEQ: false,
        termination: false,
        indemnification: false,
        insurance: false,
        heading: true,
        entire_agreement:true,
        governing: true,
        notices: true,
        customMasterServices: false
    }

    const defaultFieldsStatementOfWork = {
        services: false,
        performance_period: false,
        fees: false,
        payment_terms: false,
        customStatementOfWork: false
    }


    const changeFieldMasterServices = function (field, value) {
        let newFieldsMasterServices = { ...fieldsMasterServices }
        newFieldsMasterServices[field] = value
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        setFieldsMasterServices(newFieldsMasterServices)
        console.log("changed fields ms ", fieldsMasterServices)
    }

    const changeFieldStatementOfWork = function (field, value) {
        let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        newFieldsStatementOfWork[field] = value
        setFieldsStatementOfWork(newFieldsStatementOfWork)
    }

    const handleDefaultClause = function (keyClause, contract, checked)
    {
        props.setLoading(true)
        if (checked)
        {
            if (!defaultContractText[keyClause])
                getFieldClause(keyClause, contract, 'usa_contract', (json) =>
            {
                if (json)
                {
                    let newDefaultContractText = {...defaultContractText}
                    newDefaultContractText[keyClause] = json.clauses
                    setDefaultContractText(newDefaultContractText)
                    let newShowEdits = {...showEditClause}
                    newShowEdits[keyClause] = true
                    setShowEditClause(newShowEdits)
                    
                }
                else
                    props.setError("The requested clause text could not be fetched. This is usually due to server error.")
                props.setLoading(false)
            })
            else
            {
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = true
                setShowEditClause(newShowEdits)
                props.setLoading(false)
            }
        }
        else
        {
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
            props.setLoading(false)
        }
    }

    const [requestObj, setRequestObj] = useState({ ...defaultObj })
    const [previewUrl, setPreviewUrl] = useState()
    const [previewClicked, setPreviewClicked] = useState(false)
    const [envelopeId, setEnvelopeId] = useState("")
    const [fileArr, setFileArr] = useState([])
    const [uploadStatus, setUploadStatus] = useState('error')
    const [fieldsMasterServices, setFieldsMasterServices] = useState({ ...defaultFieldsMasterServices })
    const [fieldsStatementOfWork, setFieldsStatementOfWork] = useState({ ...defaultFieldsStatementOfWork })
    const [defaultContractText, setDefaultContractText] = useState({})
    const [showEditClause, setShowEditClause] = useState({})
    const [checkAll, setCheckAll] = useState(false)

    //separate useEffects for almost all fields w fieldsStatementOfWork
    //not for custom clause though
    useEffect(() => {
    }, [props.optionalFields])

    useEffect(() => {
        if (fieldsStatementOfWork.services)
        {
            let newObj = {...requestObj}
            newObj['document_args']['client_name'] = ""
            newObj['document_args']['service_description'] = ""
            setRequestObj(newObj)
        }  
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['client_name']
            delete newObj['document_args']['service_description']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.services])

    useEffect(() => {
        if (fieldsStatementOfWork.payment_terms)
        {
            let newObj = {...requestObj}
            newObj['document_args']['reciept_clause_included'] = true
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['reciept_clause_included']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.payment_terms])

    useEffect(() => {
        if (fieldsStatementOfWork.performance_period)
        {
            let newObj = {...requestObj}
            newObj['document_args']['effective_date'] = moment().format('YYYY-MM-DD')
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['effective_date']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.performance_period])

    useEffect(() => {
        if (fieldsStatementOfWork.fees)
        {
            let newObj = {...requestObj}
            newObj['document_args']['rate_type'] = "daily"
            newObj['document_args']['salary'] = 0
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['rate_type']
            delete newObj['document_args']['salary']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.fees])

    useEffect(() => {
            if (fileArr && fileArr.length > 0) {
                setUploadStatus('success')
            } else {
                setUploadStatus('pending')
            }
        }, [fileArr])

    useBackListener(({ location }) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
            }
        })
    
    
        useBeforeunload((event) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
    
            }
        });

    const closePreview = () => {
            setPreviewClicked(false)
            previewDocusign(envelopeId, (json) => {
                if (json) {
                    setPreviewUrl(json.redirect_url)
                }
            })
        }

    const updateDocument = (key, value) => {
            let newDoc = { ...requestObj }
            if (key == 'seq_hire_helper') {
                newDoc['document_args']['seq_hire_statement'] = defaultObj.document_args.seq_hire_statement.replace(/X/, `${value}`)
            }
                newDoc['document_args'][key] = value
            setRequestObj(newDoc)
        }

    const handleDraft = async () => {
            console.log("handleDraft")
            if (previewUrl && requestObj.id) {
                props.setLoading(true)
                submitDraft(requestObj.id, envelopeId, (resp) => {
                    if (resp) {
                        setRequestObj(defaultObj)
                        setFileArr([])
                        setPreviewUrl()
                        setEnvelopeId("")
                        if (props.onComplete) {
                            props.onComplete()
                        }
                    } else {
                        props.onError({})
                    }
                    props.setLoading(false)
                })
            } else {
                props.setLoading(true)
                setPreviewUrl()
                if (checkJson(requestObj.document_args)) {
                    getProfileFromEmail(async (profile) => 
                    {
                    let request_obj = { ...requestObj }
                    request_obj.document_b64s = await handleFile(fileArr)
                    const jsonSend = {request_obj: request_obj, contract: 'MasterServices', fields: ['fieldsMasterServices', 'fieldsStatementOfWork'], fieldsMasterServices: fieldsMasterServices, fieldsStatementOfWork: fieldsStatementOfWork, default_changes: defaultContractText, sender: profile.id}
                    createContractDraft(jsonSend, (resp) => {
                        if (resp) {
                            updateOffer('id', resp.id)
                            setPreviewUrl(resp.redirect_url)
                            setUploadStatus('disabled')
                            setEnvelopeId(resp.envelope_id)
                        } else {
                            props.onError({})
                        }
                        props.setLoading(false)
                    })
                })
                } else {
                    props.onError({ errorTitle: 'Missing Form Fields', errorContent: "Please fill out all available form fields" })
                    props.setLoading(false)
                }
    
            }
    
        }
    
    const checkJson = (json) => {
        for (const key of Object.keys(json)) {
            if (json[key] === null || json[key] === undefined || json[key] === '') {
                if (!props.optionalFields.includes(key))
                    return false
            }

            if (json[key].constructor == Object) {
                if (!checkJson(json[key])) {
                    return false
                }
                continue
            }
        }
        return true
        }
    
        const updateOffer = (key, value, del = false) => {
            let newOffer = { ...requestObj }
            if (!del) {
                newOffer[key] = value
                setRequestObj(newOffer)
            } else {
                delete newOffer[key]
                setRequestObj(newOffer)
            }
    
        }    

    const handleClear = () => {
        if (requestObj.id) {
            props.setLoading(true)
            removeOfferDraft(requestObj.id, (resp) => {
                if (resp) {
                    let newOffer = { ...requestObj }
                    delete newOffer['id']
                    setRequestObj(newOffer)
                    setPreviewUrl()
                    setUploadStatus('pending')
                } else {
                    props.onError({})
                }
                props.setLoading(false)
            })
        }
    }

    const handleFile = async (fileArr) => {
        return await fileTo64Arr(fileArr)
    }

    const handleNumberForm = (e, key, document = false, decimals = 0, maxdigits = undefined) => {
        let modfiedNum = handleFormNumbers(e.target.value, decimals, false, maxdigits)
        if (modfiedNum !== undefined) {
            if (document) {
                updateDocument(key, modfiedNum)
            } else {
                updateOffer(key, modfiedNum)
            }
        }
    }


    const handleCheckAll = (e) => {
        let newFieldsMasterServices = { ...fieldsMasterServices }
        let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
        for (const key of Object.keys(newFieldsMasterServices)) {
            newFieldsMasterServices[key] = e.target.checked
        }
        for (const key of Object.keys(newFieldsStatementOfWork)) {
            newFieldsStatementOfWork[key] = e.target.checked
        }
        setFieldsMasterServices(newFieldsMasterServices)
        setFieldsStatementOfWork(newFieldsStatementOfWork)
        setCheckAll(e.target.checked)
    }

    //Length is the maximum length of the clause in question, in case there are multiple fields
    const changeDefaultText = function (key, value, index, length)
    {
        let newDefault = {...defaultContractText}
        if (index !== undefined && newDefault[key] !== undefined)
            newDefault[key][index] = value
        else if (index !== undefined)
        {
            newDefault[key] = Array(length)
            //Populate the newly created array with the initial text from the document
            let i = 0
            while (i < length)
            {
                newDefault[key][i] = defaultContractText[key][i]
                i++
            }
            newDefault[key][index] = value
        }
        else
            newDefault[key] = value
        setDefaultContractText(newDefault)
    }

    


    return (
        <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', width: '100%', padding: '1%' }}>
            <IFramePopUp open={previewClicked} url={previewUrl} onClose={closePreview} maxRedirect={2} />
            <Typography sx ={{'align-self': 'flex-start'}} variant='h5'>Choose Fields</Typography>
            <FormGroup item sx={{ width: '100%', padding: '1%' }}>
                <FormControlLabel control={ <Checkbox checked = {checkAll} onChange = {handleCheckAll} /> } label = {"Check/Uncheck All"} />
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.non_exclusive} onChange = {(e) => changeFieldMasterServices("non_exclusive", e.target.checked)} /> } label = {"Non Exclusive Relationship"} />
                {fieldsMasterServices.non_exclusive ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.non_exclusive} onChange = {(e) => handleDefaultClause("non_exclusive", "MasterServices", e.target.checked)} /> } label = {"Edit Non Exclusive Relationship Clause"} />
                        {showEditClause.non_exclusive ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-Exclusive Relationship Clause"
                            value= {defaultContractText.non_exclusive} onChange= {(e) => changeDefaultText("non_exclusive", e.target.value)} fullWidth required multiline /> : <></>
                        }
                        
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.placement_company_employees} onChange = {(e) => changeFieldMasterServices("placement_company_employees", e.target.checked)} /> } label = {"Placement of Company Employees"} />
                {fieldsMasterServices.placement_company_employees ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.placement_company_employees} onChange = {(e) => handleDefaultClause("placement_company_employees", "MasterServices", e.target.checked)} /> } label = {"Placement of Company Employees Clause"} />
                        {showEditClause.placement_company_employees ?
                        <TextField sx = {{'margin': '1%'}} label="Current Placement of Company Employees Clause"
                            value= {defaultContractText.placement_company_employees} onChange= {(e) => changeDefaultText("placement_company_employees", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.relationship_parties} onChange = {(e) => changeFieldMasterServices("relationship_parties", e.target.checked)} /> } label = {"Relationship of the Parties"} />
                {fieldsMasterServices.relationship_parties ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.relationship_parties} onChange = {(e) => handleDefaultClause("relationship_parties", "MasterServices", e.target.checked)} /> } label = {"Relationship of the Parties Clause"} />
                        {showEditClause.relationship_parties ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 1"
                                value= {defaultContractText.relationship_parties[0]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 0, 3)} fullWidth required multiline />
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 2"
                                value= {defaultContractText.relationship_parties[1]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 1, 3)} fullWidth required multiline />
                            <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Part 3"
                            value= {defaultContractText.relationship_parties[2]} onChange= {(e) => changeDefaultText("relationship_parties", e.target.value, 2, 3)} fullWidth required multiline />

                        </>
                            : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.SEQ_duties} onChange = {(e) => changeFieldMasterServices("SEQ_duties", e.target.checked)} /> } label = {"Duties of SEQ"} />
                {fieldsMasterServices.SEQ_duties ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel item  control={ <Checkbox checked = {showEditClause.SEQ_duties} onChange = {(e) => handleDefaultClause("SEQ_duties", "MasterServices", e.target.checked)} /> } label = {"SEQ Duties Clause"} />
                        {showEditClause.SEQ_duties ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 1"
                            value= {defaultContractText.SEQ_duties[0]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 0, 5)} fullWidth required multiline /> 
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 2"
                            value= {defaultContractText.SEQ_duties[1]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 1, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 3"
                        value= {defaultContractText.SEQ_duties[2]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 2, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 4"
                        value= {defaultContractText.SEQ_duties[3]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 3, 5)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current SEQ duties Clause Part 5"
                            value= {defaultContractText.SEQ_duties[4]} onChange= {(e) => changeDefaultText("SEQ_duties", e.target.value, 4, 5)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.placement_term} onChange = {(e) => changeFieldMasterServices("placement_term", e.target.checked)} /> } label = {"Term of Placement"} />
                {fieldsMasterServices.placement_term ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.placement_term} onChange = {(e) => handleDefaultClause("placement_term", "MasterServices", e.target.checked)} /> } label = {"Edit Term of Placement Clause"} />
                        {showEditClause.placement_term ?
                        <TextField sx = {{'margin': '1%'}} label="Current Term of Placement Clause"
                            value= {defaultContractText.placement_term} onChange= {(e) => changeDefaultText("placement_term", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.intellectual_property} onChange = {(e) => changeFieldMasterServices("intellectual_property", e.target.checked)} /> } label = {"Intellectual Property"} />
                {fieldsMasterServices.intellectual_property ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.intellectual_property} onChange = {(e) => handleDefaultClause("intellectual_property", "MasterServices", e.target.checked)} /> } label = {"Edit Intellectual Property Clause"} />
                        {showEditClause.intellectual_property ?
                        <TextField sx = {{'margin': '1%'}} label="Current Intellectual Property Clause"
                            value= {defaultContractText.intellectual_property} onChange= {(e) => changeDefaultText("intellectual_property", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.non_competition_company} onChange = {(e) => changeFieldMasterServices("non_competition_company", e.target.checked)} /> } label = {"Non-Competition by Company"} />
                {fieldsMasterServices.non_competition_company ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.non_competition_company} onChange = {(e) => handleDefaultClause("non_competition_company", "MasterServices", e.target.checked)} /> } label = {"Edit Non-Competition by Company Clause"} />
                        {showEditClause.non_competition_company ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-Competition by Company Clause"
                            value= {defaultContractText.non_competition_company} onChange= {(e) => changeDefaultText("non_competition_company", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.non_competition_SEQ} onChange = {(e) => changeFieldMasterServices("non_competition_SEQ", e.target.checked)} /> } label = {"Non-Competition by SEQ"} />
                {fieldsMasterServices.non_competition_SEQ ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.non_competition_SEQ} onChange = {(e) => handleDefaultClause("non_competition_SEQ", "MasterServices", e.target.checked)} /> } label = {"Edit Non-Competition by SEQ Clause"} />
                        {showEditClause.non_competition_SEQ ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-Competition by SEQ Clause"
                            value= {defaultContractText.non_competition_SEQ} onChange= {(e) => changeDefaultText("non_competition_SEQ", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.termination} onChange = {(e) => changeFieldMasterServices("termination", e.target.checked)} /> } label = {"Termination"} />
                {fieldsMasterServices.termination ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.termination} onChange = {(e) => handleDefaultClause("termination", "MasterServices", e.target.checked)} /> } label = {"Edit Termination Clause"} />
                        {showEditClause.termination ?
                        <TextField sx = {{'margin': '1%'}} label="Current Termination Clause"
                            value= {defaultContractText.termination} onChange= {(e) => changeDefaultText("termination", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.indemnification} onChange = {(e) => changeFieldMasterServices("indemnification", e.target.checked)} /> } label = {"Indemnification"} />
                {fieldsMasterServices.indemnification ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.indemnification} onChange = {(e) => handleDefaultClause("indemnification", "MasterServices", e.target.checked)} /> } label = {"Edit Indemnification Clause"} />
                        {showEditClause.indemnification ?
                        <TextField sx = {{'margin': '1%'}} label="Current Indemnification Clause"
                            value= {defaultContractText.indemnification} onChange= {(e) => changeDefaultText("indemnification", e.target.value)} fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.insurance} onChange = {(e) => changeFieldMasterServices("insurance", e.target.checked)} /> } label = {"Insurance"} />
                {fieldsMasterServices.insurance ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        
                        <FormControlLabel item  control={ <Checkbox checked = {showEditClause.insurance} onChange = {(e) => handleDefaultClause("insurance", "MasterServices", e.target.checked)} /> } label = {"Edit Insurance Clause"} />
                        {showEditClause.insurance ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 1"
                            value= {defaultContractText.insurance[0]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 0, 6)} fullWidth required multiline /> 
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 2"
                            value= {defaultContractText.insurance[1]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 1, 6)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 3"
                        value= {defaultContractText.insurance[2]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 2, 6)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 4"
                        value= {defaultContractText.insurance[3]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 3, 6)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 5"
                            value= {defaultContractText.insurance[4]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 4, 6)} fullWidth required multiline />
                        <TextField sx = {{'margin': '1%'}} label="Current Insurance Clause Part 6"
                            value= {defaultContractText.insurance[5]} onChange= {(e) => changeDefaultText("insurance", e.target.value, 5, 6)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.customMasterServices} onChange = {(e) => changeFieldMasterServices("customMasterServices", e.target.checked)} /> } label = {"Add a Master Professional Services Custom Field"} />
                {fieldsMasterServices.customMasterServices ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Master Services Custom Header"
                                value= {defaultContractText.customMasterServicesHeader} onChange= {(e) => changeDefaultText("customMasterServicesHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Master Services Custom Clause"
                                value= {defaultContractText.customMasterServices} onChange= {(e) => changeDefaultText("customMasterServices", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.services} onChange = {(e) => changeFieldStatementOfWork("services", e.target.checked)} /> } label = {"Statement of Work Services"} />
                {fieldsStatementOfWork.services ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.services} onChange = {(e) => handleDefaultClause("services", "StatementOfWork", e.target.checked)} /> } label = {"Edit Services Clause"} />
                        {showEditClause.services ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                            The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Services Clause"
                                value= {defaultContractText.services} onChange= {(e) => changeDefaultText("services", e.target.value)} fullWidth required multiline />     
                        </> 
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.fees} onChange = {(e) => changeFieldStatementOfWork("fees", e.target.checked)} /> } label = {"Statement of Work Fees"} />
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.performance_period} onChange = {(e) => changeFieldStatementOfWork("performance_period", e.target.checked)} /> } label = {"Statement of Work Performance Period"} />
                {fieldsStatementOfWork.performance_period ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.performance_period} onChange = {(e) => handleDefaultClause("performance_period", "StatementOfWork", e.target.checked)} /> } label = {"Edit Performance Period Clause"} />
                        {showEditClause.performance_period ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Performance Period Clause"
                                value= {defaultContractText.performance_period} onChange= {(e) => changeDefaultText("performance_period", e.target.value)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.payment_terms} onChange = {(e) => changeFieldStatementOfWork("payment_terms", e.target.checked)} /> } label = {"Statement of Work Payment Terms"} />
                {fieldsStatementOfWork.payment_terms ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.payment_terms} onChange = {(e) => handleDefaultClause("payment_terms", "StatementOfWork", e.target.checked)} /> } label = {"Edit Payment Terms Clause"} />
                        {showEditClause.payment_terms ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Payment Terms Clause"
                                value= {defaultContractText.payment_terms} onChange= {(e) => changeDefaultText("payment_terms", e.target.value)} fullWidth required multiline /> 
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.customStatementOfWork} onChange = {(e) => changeFieldStatementOfWork("customStatementOfWork", e.target.checked)} /> } label = {"Add a Statement of Work Custom Field"} />
                {fieldsStatementOfWork.customStatementOfWork ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Header"
                                value= {defaultContractText.customStatementOfWorkHeader} onChange= {(e) => changeDefaultText("customStatementOfWorkHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Clause"
                                value= {defaultContractText.customStatementOfWork} onChange= {(e) => changeDefaultText("customStatementOfWork", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
            </FormGroup>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Name" onChange={(e) => { e.preventDefault(); updateOffer('name', e.target.value) }}
                            value={requestObj.name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Contractor Name" onChange={(e) => { e.preventDefault(); updateDocument('contractor_name', e.target.value) }}
                            value={requestObj.document_args.contractor_name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Company Name" onChange={(e) => { e.preventDefault(); updateDocument('company_name', e.target.value) }}
                            value={requestObj.document_args.company_name} fullWidth required />
                    </Grid>
                    { fieldsStatementOfWork.services ? 
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Client Name" onChange={(e) => { e.preventDefault(); updateDocument('client_name', e.target.value) }}
                            value={requestObj.document_args.client_name} fullWidth required />
                    </Grid> : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Employer ID Number" onChange={(e) => { e.preventDefault(); updateDocument('employer_id', e.target.value) }}
                            value={requestObj.document_args.employer_id} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Employer Address" onChange={(e) => { e.preventDefault(); updateDocument('employer_address', e.target.value) }}
                            value={requestObj.document_args.employer_address} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Email" onChange={(e) => { e.preventDefault(); updateOffer('email_address', e.target.value) }}
                            value={requestObj.email_address} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Job Title" onChange={(e) => { e.preventDefault(); updateDocument('job_title', e.target.value) }}
                            value={requestObj.document_args.job_title} fullWidth required />
                    </Grid>
                    {fieldsStatementOfWork.performance_period ? 
                        <Grid item xs={3}>
                        <DatePicker disabled={Boolean(previewUrl)} label="SOW Effective Date" value={requestObj.document_args.effective_date}
                            onChange={(value) => updateDocument('effective_date', value.format('YYYY-MM-DD').toString())}
                            renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid>
                        : <></>
                    }
                    { fieldsStatementOfWork.fees ?
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} label="Payment Type" required onChange={(e) => { e.preventDefault(); updateDocument('rate_type', e.target.value) }}
                                value={requestObj.document_args.rate_type} fullWidth select>
                                <MenuItem key={1} value="daily">
                                    Daily
                                </MenuItem>
                                <MenuItem key={2} value="hourly">
                                    Hourly
                                </MenuItem>
                            </TextField>
                        </Grid> : <></> }
                    { fieldsStatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'salary', true, 2)
                            }}
                                label={requestObj.document_args.rate_type == 'daily' ? "Daily Rate ($)" : 'Hourly Rate ($/hr)'}
                                value={requestObj.document_args.salary} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    {fieldsStatementOfWork.services ?
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Service Description" onChange={(e) => { e.preventDefault(); updateDocument('service_description', e.target.value) }}
                            value={requestObj.document_args.service_description} fullWidth required multiline />
                    </Grid>
                    : <></> }   
                    <Grid item xs={3}>
                        <TextField disabled={true} label="SEQ Non-Competition Statement"
                            value= {requestObj.document_args.seq_hire_statement} fullWidth required multiline />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="SEQ Non-Competition Statement Month(s)"
                            onChange={(e) => {
                                e.preventDefault();
                                let val = e.target.value.replace(/\D/, '')
                                updateDocument('seq_hire_helper', val)
                            }}
                            value={requestObj.document_args.seq_hire_helper} fullWidth required multiline />
                    </Grid>
                    { fieldsStatementOfWork.payment_terms ?
                    <Grid item xs={3}>
                        <TextField label="5 Days Reciept Clause Included" required disabled={previewUrl} onChange={(e) => { e.preventDefault(); updateDocument('reciept_clause_included', e.target.value) }}
                            value={requestObj.document_args.reciept_clause_included} fullWidth select>
                            <MenuItem value={true}>
                                Yes
                            </MenuItem>
                            <MenuItem value={false}>
                                No
                            </MenuItem>
                        </TextField>
                    </Grid>
                    : <></> }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Jurisdiction"
                            onChange={(e) => { e.preventDefault(); updateOffer('state_id', e.target.value) }}
                            value={requestObj.state_id} fullWidth select>
                            {props.states.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl) || !requestObj.state_id} required label="Venue"
                            onChange={(e) => { e.preventDefault(); updateOffer('venue_id', e.target.value) }}
                            value={requestObj.venue_id} fullWidth select>
                            {props.venues.filter(v => v.type === requestObj.state_id).map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Signing Authority" onChange={(e) => { e.preventDefault(); updateOffer('authority_id', e.target.value) }}
                            value={requestObj.authority_id} fullWidth select>
                            {props.authorities.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}({auth.email_address})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Statement Of Work Number"
                            onChange={(e) => {
                                e.preventDefault();
                                updateDocument('SOW_number', e.target.value)
                            }}
                            value={requestObj.document_args.SOW_number} fullWidth required multiline />
                    </Grid>
                    <GridBreak />
                    <Grid item container xs={12} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <DragFiles types={props.fileTypes} multiple={true} disabled={Boolean(previewUrl)} onUpdate={setFileArr}
                            maxSize={15}
                            onTypeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Type Error', errorContent: error }) }}
                            onSizeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Size Error', errorContent: error }) }}
                            uploadStatus={uploadStatus} />
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); handleClear() }}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); setPreviewClicked(true) }}>Preview Document</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Button fullWidth onClick={(e) => { e.preventDefault(); handleDraft() }}>{requestObj.id && previewUrl ? "Send" : "Create Draft"}</Button>
                    </Grid>
                </Grid>
    );
}

export default MasterOfServicesUSA;